import { useFeatureFlags } from 'utils/featureFlags'

/**
 * Hook that provides consistent terminology based on the appToDatabaseRename feature flag.
 * Returns an object with all the different text variations used throughout the app.
 */
export function useAppToDatabaseRename() {
  const { appToDatabaseRename } = useFeatureFlags()

  return {
    // Lowercase versions
    databaseText: appToDatabaseRename ? 'database' : 'app',
    databasesText: appToDatabaseRename ? 'databases' : 'apps',

    // Title case versions
    titleText: appToDatabaseRename ? 'Database' : 'App',
    titlePluralText: appToDatabaseRename ? 'Databases' : 'Apps',

    // Article versions
    articleText: appToDatabaseRename ? 'a database' : 'an app',

    // Specific UI text
    idText: appToDatabaseRename ? 'Database ID' : 'App ID',
    authModeText: appToDatabaseRename ? 'Development' : 'Playground',
    tokenText: appToDatabaseRename ? 'Development token' : 'Playground token',

    // Direct flag access for edge cases
    isRenamed: appToDatabaseRename,
  }
}
